import { config, zSpaceConfig } from '../config';
import { Object3D, Vector3 } from 'three';
import { ActionControllerEventName, ParentEvent, ResourcesManager, ScenarioProcessor, Viewer, ViewerModule } from '@verybigthings/vbt-webvr-framework';
import TaskScreen from '../components/TaskScreen';
import TasksProgress from '../components/TasksProgress';
import WelcomeScreen from '../components/WelcomeScreen';
import PeriodicModule from './MolarModules/PeriodicModule';
import SummationModule from './MolarModules/SummationModule';
import FunnelModule from './MolarModules/FunnelModule';
import ScalesBowlModule from './MolarModules/ScalesBowlModule';
import FlaskModule from './MolarModules/FlaskModule';
import DistilledWaterModule from './MolarModules/DistilledWaterModule';
import LabelModule from './MolarModules/LabelModule';
import JarModule from './MolarModules/JarModule';
import CapModule from './MolarModules/CapModule';
import ResultJarModule from './MolarModules/ResultJarModule';
import LobbyScreen from '../components/LobbyScreen';
import ErrorModal from '../components/ErrorModal';
import { deepClone } from '@verybigthings/vbt-webvr-framework/build/main/ts/utils/DeepClone';
import { MaterialImprovement } from '../utils/MaterialImprovement';
import { PickingControllerEvents } from '@verybigthings/vbt-webvr-framework/build/main/ts/controls/PickingController';
import { SpoonModule } from './MolarModules/SpoonModule';
import { PreparationPickingObjects } from "../utils/PreparationPickingObjects";
export default class MolarLevel extends ViewerModule {
    constructor(levelNumber, title, lobby) {
        super();
        this.lobby = lobby;
        this.__inited = false;
        this.cameraPositionVR = new Vector3(18.507, -15.598, -1.729);
        this.wrapScreenPosition = new Vector3(-3.52, 1.54, -5.15);
        this.levelFinished = false;
        this._interaction = false;
        this.uiObject.name = 'MOLAR LEVEL';
        this.resourcesInUse = [];
        this.viewerConf = config;
        this.pointerController = Viewer.pointerController;
        this.cameraPosition = new Vector3(18.507, -13.598, -1.729);
        this.cameraTargetNormal = new Vector3(18.512, -13.6, -1.738);
        this.zSpacePositions = zSpaceConfig.molar;
        this.initUI();
        this.addLobbyUI(levelNumber, title);
        this.initModules();
        this.initScenario();
    }
    get interaction() {
        return this._interaction;
    }
    set interaction(value) {
        this._interaction = value;
        console.log('MOLAR LEVEL INTERACTION = ', this._interaction);
    }
    addLobbyUI(levelNumber, title) {
        let lobbyUI = new Object3D();
        lobbyUI.name = 'LOBBY UI';
        this.addObject(lobbyUI);
        this.title = new LobbyScreen();
        this.title.init('Level ' + levelNumber, title, '0/9');
        lobbyUI.add(this.title.uiObject);
        this.title.uiObject.position.y = 10;
        this.title.on('start', () => {
            if (this.pointerController.currentPointerObject !== this.pointerController.defaultPointerObject)
                return;
            this.fire('start', new ParentEvent('start'));
        });
        this.on('started', () => this.interaction = true);
        this.title.on('tutorial', () => this.fire('tutorial'));
    }
    initUI() {
        this.uiContainer = new Object3D();
        this.uiContainer.name = 'uiContainer';
        this.uiContainer.position.z = -5;
        this.uiContainer.userData.pcPosition = this.uiContainer.position.clone();
        this.uiContainer.visible = false;
        this.addObject(this.uiContainer);
        this.tasksProgress = new TasksProgress();
        this.tasksProgress.uiObject.name = 'TASK PROGRESS';
        this.tasksProgress.uiObject.position.set(0, 4.7, 0);
        this.tasksProgress.init(9, -1);
        this.uiContainer.add(this.tasksProgress.uiObject);
        this.taskScreen = new TaskScreen();
        this.taskScreen.uiObject.name = 'TASK SCREEN';
        this.taskScreen.uiObject.position.set(0, 0, 0);
        this.uiContainer.add(this.taskScreen.uiObject);
        this.welcomeScreen = new WelcomeScreen();
        this.welcomeScreen.uiObject.name = 'WELCOME_POP_UP';
        this.welcomeScreen.uiObject.position.set(0, -0.2, 0.5);
        this.uiContainer.add(this.welcomeScreen.uiObject);
        this.errorModal = new ErrorModal();
        this.errorModal.uiObject.name = 'ERROR MODAL';
        this.uiContainer.add(this.errorModal.uiObject);
        this.errorModal.on('ok', () => this.errorModal.uiObject.visible = false);
        this.errorModal.init('Error', 'Wrong value entered. \n Try again.');
        this.errorModal.uiObject.position.set(0, 0, 4.64);
        this.errorModal.uiObject.visible = false;
    }
    initModules() {
        if (this.table) {
            this.table.traverse(el => {
                if (this.lobby.app.zSpacePickingController)
                    this.lobby.app.zSpacePickingController.off(null, el);
                el.visible = false;
            });
            this.uiObject.traverse(el => {
                if (this.lobby.app.zSpacePickingController)
                    this.lobby.app.zSpacePickingController.off(null, el);
            });
            this.disposeObject(this.periodicModule);
            this.disposeObject(this.summationModule);
            this.disposeObject(this.summationGramModule);
            this.disposeObject(this.table);
            this.disposeObject(this.jarModule);
            this.disposeObject(this.funnelModule);
            this.disposeObject(this.scalesBowlModule);
            this.disposeObject(this.flaskModule);
            this.disposeObject(this.distilledWaterModule);
            this.disposeObject(this.labelModule);
            this.disposeObject(this.capModule);
            this.disposeObject(this.resultJarModule);
            this.disposeObject(this.spoonModule_1);
            this.disposeObject(this.spoonModule_0_1);
            this.disposeObject(this.spoonModule_0_5);
        }
        this.table = deepClone(ResourcesManager.getModel('scene_molar'));
        this.table.name = 'TABLE';
        const newTable = ResourcesManager.getModel('micropipette_table').clone();
        newTable.getObjectByName('pPlane1').visible = false;
        newTable.scale.set(.78, 1, 1.08);
        this.table.add(newTable);
        this.table.getObjectByName('table').visible = false;
        MaterialImprovement.upgradeMaterialsFromModel(this.table, this.uiObject.name);
        // FOR ZSPACE OPTIMIZE
        const molarFloorShadowModel = ResourcesManager.getModel('molar_floor_shadow');
        if (molarFloorShadowModel) {
            const floorShadow = deepClone(molarFloorShadowModel).children[0];
            floorShadow.position.y += 0.15;
            floorShadow.material.color.set(0x000000);
            floorShadow.material.alphaMap = ResourcesManager.getTexture('molar_floor_shadow_alpha');
            floorShadow.material.transparent = true;
            this.table.add(floorShadow);
        }
        this.table.position.set(0, -7, 0);
        this.addObject(this.table);
        this.scalesBowl = this.table.getObjectByName('polySurface56');
        this.flask = this.table.getObjectByName('polySurface60');
        this.periodicModule = new PeriodicModule(this);
        this.periodicModule.uiObject.visible = false;
        this.uiContainer.add(this.periodicModule.uiObject);
        this.summationModule = new SummationModule();
        this.uiContainer.add(this.summationModule.uiObject);
        this.summationModule.show(false);
        this.summationModule.uiObject.position.set(0, -3.8, 0);
        this.summationModule.uiObject.userData.pcPosition = this.summationModule.uiObject.position.clone();
        if (Viewer.controls.zController) {
            this.summationModule.uiObject.position.set(0, -5.4, 0);
            this.summationModule.uiObject.scale.setScalar(1.5 / this.lobby.app.determineZSpaceDevice.viewerScaleCoef);
        }
        this.summationGramModule = new SummationModule(true);
        this.uiContainer.add(this.summationGramModule.uiObject);
        this.summationGramModule.show(false);
        this.summationGramModule.uiObject.position.set(0, -0.2, 0);
        if (!Viewer.controls.zController) {
            this.summationGramModule.uiObject.scale.setScalar(0.8);
            this.summationGramModule.uiObject.position.z = 4.5;
        }
        this.summationGramModule.uiObject.userData.pcPosition = this.summationGramModule.uiObject.position.clone();
        this.addObject(this.jarModule = new JarModule(this.table.getObjectByName('jar_salt'), this.table, this.uiContainer, this));
        this.addObject(this.funnelModule = new FunnelModule(this.table.getObjectByName('funnel'), this.table, this.uiContainer, this));
        this.addObject(this.scalesBowlModule = new ScalesBowlModule(this.table.getObjectByName('scale_bowl'), this.table, this.uiContainer, this));
        this.addObject(this.flaskModule = new FlaskModule(this.table.getObjectByName('flask_water'), this.table, this.uiContainer, this));
        this.addObject(this.distilledWaterModule = new DistilledWaterModule(this.table.getObjectByName('water_bottle'), this.table, this.uiContainer, this));
        this.addObject(this.labelModule = new LabelModule(this.table.getObjectByName('label'), this.table, this.uiContainer, this));
        this.addObject(this.capModule = new CapModule(this.table.getObjectByName('flask_cap'), this.table, this.flaskModule.model, this.uiContainer, this));
        this.addObject(this.resultJarModule = new ResultJarModule(this.table.getObjectByName('result_jar'), this.table, this.uiContainer, this));
        this.addObject(window['spoonModule_1'] = this.spoonModule_1 = new SpoonModule(this, '1.0'));
        this.addObject(window['spoonModule_0_1'] = this.spoonModule_0_1 = new SpoonModule(this, '0.1'));
        this.addObject(window['spoonModule_0_5'] = this.spoonModule_0_5 = new SpoonModule(this, '0.5'));
        if (Viewer.controls.zController) {
            this.spoonModule_1.uiObject.visible = this.spoonModule_0_1.uiObject.visible = this.spoonModule_0_5.uiObject.visible = false;
        }
        this.spoonModule_1.init();
        this.spoonModule_1.uiObject.position.set(-2.7210041667299962 - 0.6, -3.842382081887899, 1.4728 + 0.16);
        this.spoonModule_1.uiObject.rotation.set(-1.472567813763378, -1.5111012934440067, -1.8119090535615132);
        // this.spoonModule_1.setDraggable(true);
        this.spoonModule_0_1.init();
        this.spoonModule_0_1.uiObject.position.set(-2.6825368889652585 - 0.6, -3.872299987486957, 2.66733 + 0.16);
        this.spoonModule_0_1.uiObject.rotation.set(-2.5115205624844466, -1.5354812034912797, -2.7905588758684647);
        // this.spoonModule_0_1.setDraggable(true);
        this.spoonModule_0_5.init();
        this.spoonModule_0_5.uiObject.position.set(-2.7010615976784322 - 0.6, -3.8572156057976175, 2.12 + 0.16);
        this.spoonModule_0_5.uiObject.rotation.set(-2.759810615506144, -1.5244663298686554, -3.0810475821155077);
        // this.spoonModule_0_5.setDraggable(true);
        // this.addObject(this.uiContainer);
    }
    initScenario() {
        // FOR FASTER DEVELOPMENT
        // this.taskScreen.uiObject.position.set(10, 0, 0);
        // this.welcomeScreen.show(false);
        // this.periodicModule.show(false);
        var _a;
        this.scenarioConfig = {
            name: 'molarLevelScenario',
            modules: [
                { name: 'errorModal', instance: this.errorModal },
                { name: 'tasksProgress', instance: this.tasksProgress },
                { name: 'taskScreen', instance: this.taskScreen },
                { name: 'welcomeScreen', instance: this.welcomeScreen },
                { name: 'lobbyScreen', instance: this.title },
                { name: 'periodicModule', instance: this.periodicModule },
                { name: 'summationModule', instance: this.summationModule },
                { name: 'summationGramModule', instance: this.summationGramModule },
                { name: 'jarModule', instance: this.jarModule },
                { name: 'scalesBowlModule', instance: this.scalesBowlModule },
                { name: 'flaskModule', instance: this.flaskModule },
                { name: 'distilledWaterModule', instance: this.distilledWaterModule },
                { name: 'funnelModule', instance: this.funnelModule },
                { name: 'labelModule', instance: this.labelModule },
                { name: 'capModule', instance: this.capModule },
                { name: 'resultJarModule', instance: this.resultJarModule },
            ],
            steps: [
                {
                    onBefore: [
                        ['tasksProgress', 'init', 9, -1],
                        ['lobbyScreen', 'setProgress', '0/9'],
                        ['welcomeScreen', 'init', 'Welcome!', 'In this level we will be creating 100 ml of a 1 molar sodium chloride (NaCl) solution.', 'START!'],
                        ['welcomeScreen', 'show', true]
                    ],
                    stepCondition: () => new Promise((resolve, reject) => {
                        this.taskScreen.uiObject.rotation.set(0, 0, 0);
                        this.welcomeScreen.off('ok');
                        this.welcomeScreen.once('ok', () => {
                            this.interaction = true;
                            resolve();
                        });
                    }),
                    onAfter: [
                        ['welcomeScreen', 'show', false],
                        ['taskScreen', 'flyTo', new Vector3(9.24, 0, 7.55), 1000],
                        ['tasksProgress', 'flyTo', new Vector3(0, 4, 6.72), 1000],
                        ['summationModule', 'flyTo', new Vector3(0, -3.21, 7.08), 1000],
                        ['periodicModule', 'zoomIn']
                    ]
                },
                // wait select Na
                {
                    onBefore: [
                        ['tasksProgress', 'init', 9, 0],
                        [
                            'taskScreen', 'init', 'TASK 1',
                            'Find the molar mass of sodium chloride.',
                            'Select Sodium and Chlorine on the periodic table to add together their atomic masses.',
                            0.9
                        ],
                        ['taskScreen', 'show', true],
                        ['periodicModule', 'initWaitSelectElements'],
                        ['summationModule', 'show']
                    ],
                    stepCondition: () => new Promise((resolve, reject) => {
                        let firstElementSelected = false;
                        this.periodicModule.once('on_Na', () => {
                            this.summationModule.addNa();
                            if (firstElementSelected)
                                resolve();
                            firstElementSelected = true;
                        });
                        this.periodicModule.once('on_Cl', () => {
                            this.summationModule.addCl();
                            if (firstElementSelected)
                                resolve();
                            firstElementSelected = true;
                        });
                    }),
                    onAfter: [
                        ['summationModule', 'showResult'],
                        ['periodicModule', 'show', false],
                        ['taskScreen', 'flyTo', new Vector3(10, 0, 0), 1000],
                        ['tasksProgress', 'flyTo', new Vector3(0, 3.84, 0), 1000],
                        ['tasksProgress', 'init', 9, 1],
                        ['lobbyScreen', 'setProgress', '1/9']
                    ]
                },
                {
                    onBefore: [
                        [
                            'taskScreen', 'init', 'TASK 2',
                            'Divide the molar mass by 10 to convert it into grams.',
                            'Use the keypad to enter 10 and then press enter.',
                            .9
                        ],
                        ['summationModule', 'flyTo', new Vector3(0, 1.55, 4.5), 1000, () => this.summationGramModule.show()]
                    ],
                    stepCondition: () => new Promise((resolve, reject) => {
                        this.summationGramModule.once('successfully_entered', resolve);
                        this.summationGramModule.once('wrong_entered', () => {
                            this.errorModal.once('ok', () => this.summationGramModule.input.uiObject.visible = true);
                            reject();
                        });
                    }),
                    onError: [
                        ['errorModal', 'init', 'Error', 'Wrong value entered. \n Try again.', 'ok'],
                        ['errorModal', 'setVisible', true]
                    ],
                    onAfter: [
                        ['summationModule', 'show', false],
                        ['summationGramModule', 'show', false]
                    ]
                },
                {
                    onBefore: [
                        ['tasksProgress', 'init', 9, 2],
                        ['lobbyScreen', 'setProgress', '2/9'],
                        [
                            'taskScreen', 'init', 'TASK 3',
                            'Pour 5.8g of Sodium Chloride(NaCl) in to the dish.',
                            'Using 0.1, 0.5 and 1 gram spoons, put 5.8g of NaCl in a bowl on a scale.',
                            0.7
                        ],
                        ['taskScreen', 'flyTo', new Vector3(0, 0, -0.1)]
                    ],
                    stepCondition: () => new Promise((resolve, reject) => {
                        this.scalesBowlModule.startPourFromJar();
                        this.jarModule.pourToScaleBowl();
                        this.jarModule.once('scalesBowl_filled', () => {
                            [this.spoonModule_0_1, this.spoonModule_0_5, this.spoonModule_1].forEach(spoon => {
                                spoon.setDraggable(false);
                            });
                            resolve();
                        });
                        [this.spoonModule_0_1, this.spoonModule_0_5, this.spoonModule_1].forEach(spoon => {
                            spoon.setDraggable(true);
                            if (Viewer.controls.zController) {
                                let oldDistanceToBowl = 1000, oldDistanceToJar = 1000;
                                let enableBowl = true, enableJar = true;
                                this.lobby.app.zSpacePickingController.on(PickingControllerEvents.MOVED, spoon.uiObject, () => {
                                    const spoonPosition = spoon.uiObject.localToWorld(new Vector3(0, 0, 0));
                                    const distanceToJar = spoonPosition.distanceTo(this.jarModule.model.localToWorld(new Vector3()));
                                    const distanceToBowl = spoonPosition.distanceTo(this.scalesBowlModule.model.localToWorld(new Vector3()));
                                    if (distanceToBowl < 0.35 && enableBowl) {
                                        if (spoon.addedSalt) {
                                            spoon.removeSalt();
                                            let newVal = this.scalesBowlModule.maxSaltWeight + spoon.numericalWeight;
                                            this.scalesBowlModule.plusMass(newVal);
                                            this.jarModule.applyButton.uiObject.visible = true;
                                        }
                                        else if (this.scalesBowlModule.maxSaltWeight > 0) {
                                            spoon.addSalt();
                                            let newVal = this.scalesBowlModule.maxSaltWeight - spoon.numericalWeight;
                                            if (newVal <= 0) {
                                                newVal = 0;
                                                this.jarModule.applyButton.uiObject.visible = false;
                                            }
                                            this.scalesBowlModule.plusMass(newVal);
                                        }
                                        enableBowl = false;
                                    }
                                    oldDistanceToBowl = distanceToBowl;
                                    if (distanceToJar < 0.3 && enableJar) {
                                        if (spoon.addedSalt)
                                            spoon.removeSalt();
                                        else
                                            spoon.addSalt();
                                        enableJar = false;
                                    }
                                    oldDistanceToJar = distanceToJar;
                                    if (distanceToJar > 0.9)
                                        enableJar = true;
                                    if (distanceToBowl > 0.9)
                                        enableBowl = true;
                                });
                            }
                            else {
                                this.actionController.on(ActionControllerEventName.click, this.jarModule.model.children[0], (event) => {
                                    if (this.lobby.app.pointerController.currentPointerObject === spoon.uiObject) {
                                        if (spoon.addedSalt)
                                            spoon.removeSalt();
                                        else
                                            spoon.addSalt();
                                    }
                                });
                                this.actionController.on(ActionControllerEventName.click, this.scalesBowlModule.model, (event) => {
                                    if (this.lobby.app.pointerController.currentPointerObject === spoon.uiObject) {
                                        if (spoon.addedSalt) {
                                            spoon.removeSalt();
                                            let newVal = this.scalesBowlModule.maxSaltWeight + spoon.numericalWeight;
                                            this.scalesBowlModule.plusMass(newVal);
                                            this.jarModule.applyButton.uiObject.visible = true;
                                        }
                                        else if (this.scalesBowlModule.maxSaltWeight > 0) {
                                            spoon.addSalt();
                                            let newVal = this.scalesBowlModule.maxSaltWeight - spoon.numericalWeight;
                                            if (newVal <= 0) {
                                                newVal = 0;
                                                this.jarModule.applyButton.uiObject.visible = false;
                                            }
                                            this.scalesBowlModule.plusMass(newVal);
                                        }
                                    }
                                });
                            }
                        });
                    }),
                    onAfter: [['jarModule', 'setDefaultPositionRotation']]
                },
                {
                    onBefore: [
                        ['tasksProgress', 'init', 9, 3],
                        ['lobbyScreen', 'setProgress', '3/9'],
                        [
                            'taskScreen', 'init', 'TASK 4',
                            'Transfer sodium chloride into the flask.',
                            'First, select the funnel on the table and place it on top of the flask. \n ' +
                                'Then, drag the bowl from the scale to pour it through the funnel into the flask.',
                            0.48
                        ]
                    ],
                    stepCondition: () => new Promise((resolve, reject) => {
                        [this.spoonModule_0_1, this.spoonModule_0_5, this.spoonModule_1].forEach(spoon => {
                            spoon.setDraggable(false);
                        });
                        const callback = () => {
                            this.funnelModule.model.rotateZ(Math.PI);
                            Viewer.pointerController.setObject(this.funnelModule.model);
                            this.funnelModule.visibilityShadow(false);
                            resolve();
                        };
                        const initFunction = () => {
                            this.actionController.once(ActionControllerEventName.click, this.funnelModule.model, (event) => {
                                if (Viewer.controls.zController)
                                    return;
                                if (!this.interaction || event.intersectedObject.name === 'pPlane') {
                                    initFunction();
                                    return;
                                }
                                callback();
                            });
                            if (Viewer.controls.zController && this.lobby.app.zSpacePickingController) {
                                let isBeReleased = false;
                                PreparationPickingObjects.saveObjectState(this.funnelModule.model);
                                this.lobby.app.zSpacePickingController.on(PickingControllerEvents.PICKED, this.funnelModule.model, () => {
                                    if (!this.interaction)
                                        return;
                                    Viewer.scene.add(this.funnelModule.model);
                                    this.funnelModule.model.rotateZ(Math.PI);
                                    this.funnelModule.model.rotateZ(Math.PI);
                                    this.funnelModule.visibilityShadow(false);
                                    resolve();
                                });
                                this.lobby.app.zSpacePickingController.on(PickingControllerEvents.MOVED, this.funnelModule.model, () => {
                                    if (!isBeReleased)
                                        this.funnelModule.model.rotateZ(Math.PI);
                                });
                                this.lobby.app.zSpacePickingController.on(PickingControllerEvents.RELEASED, this.funnelModule.model, () => {
                                    isBeReleased = true;
                                });
                            }
                        };
                        initFunction();
                    }),
                    onAfter: []
                },
                {
                    onBefore: [],
                    stepCondition: () => new Promise((resolve, reject) => {
                        const callback = () => {
                            Viewer.pointerController.setObject(null);
                            this.table.add(this.funnelModule.model);
                            this.funnelModule.putInFlask();
                            resolve();
                        };
                        const initFunction = () => {
                            this.actionController.once(ActionControllerEventName.click, this.flaskModule.model, (event) => {
                                if (Viewer.controls.zController)
                                    return;
                                if (!this.interaction || event.intersectedObject.name === 'pPlane') {
                                    initFunction();
                                    return;
                                }
                                callback();
                            });
                            if (Viewer.controls.zController && this.lobby.app.zSpacePickingController) {
                                this.lobby.app.zSpacePickingController.on(PickingControllerEvents.RELEASED, this.funnelModule.model, () => {
                                    const distanceToFlask = this.funnelModule.model.getWorldPosition(new Vector3()).distanceTo(this.flaskModule.flaskTopPosition);
                                    if (distanceToFlask < 1) {
                                        this.actionController.off(ActionControllerEventName.click, this.flaskModule.model);
                                        this.lobby.app.zSpacePickingController.off(PickingControllerEvents.PICKED, this.funnelModule.model);
                                        this.lobby.app.zSpacePickingController.off(PickingControllerEvents.MOVED, this.funnelModule.model);
                                        this.lobby.app.zSpacePickingController.off(PickingControllerEvents.RELEASED, this.funnelModule.model);
                                        this.table.add(this.funnelModule.model);
                                        this.funnelModule.putInFlask();
                                        resolve();
                                    }
                                    else {
                                        PreparationPickingObjects.flyObjectToPrevState(this.funnelModule.model);
                                    }
                                    setTimeout(() => this.funnelModule.model.traverse(el => {
                                        if (el.userData.oldRaycast)
                                            el.raycast = el.userData.oldRaycast;
                                    }));
                                });
                            }
                        };
                        initFunction();
                    }),
                    onAfter: []
                },
                {
                    onBefore: [],
                    stepCondition: () => new Promise((resolve, reject) => {
                        const callback = () => {
                            this.scalesBowlModule.setToPointerController();
                            this.scalesBowlModule.clearWeight();
                            resolve();
                        };
                        const initFunction = () => {
                            this.actionController.once(ActionControllerEventName.click, this.scalesBowlModule.model, (event) => {
                                if (Viewer.controls.zController)
                                    return;
                                if (!this.interaction || event.intersectedObject.name === 'pPlane') {
                                    initFunction();
                                    return;
                                }
                                callback();
                            });
                            if (Viewer.controls.zController && this.lobby.app.zSpacePickingController) {
                                PreparationPickingObjects.saveObjectState(this.scalesBowlModule.model);
                                this.lobby.app.zSpacePickingController.on(PickingControllerEvents.PICKED, this.scalesBowlModule.model, (event) => {
                                    if (!this.interaction)
                                        return;
                                    Viewer.scene.add(this.scalesBowlModule.model);
                                    this.scalesBowlModule.clearWeight();
                                    resolve();
                                });
                            }
                        };
                        initFunction();
                    }),
                    onAfter: []
                },
                {
                    onBefore: [],
                    stepCondition: () => new Promise((resolve, reject) => {
                        const callback = () => {
                            this.flaskModule.setSaltWeight(this.scalesBowlModule.getWeight());
                            this.scalesBowlModule.pourIntoFlask(resolve);
                        };
                        const initFunction = () => {
                            this.actionController.once(ActionControllerEventName.click, this.funnelModule.model, (event) => {
                                if (Viewer.controls.zController)
                                    return;
                                if (!this.interaction || event.intersectedObject.name === 'pPlane') {
                                    initFunction();
                                    return;
                                }
                                callback();
                            });
                            if (Viewer.controls.zController && this.lobby.app.zSpacePickingController) {
                                this.lobby.app.zSpacePickingController.on(PickingControllerEvents.RELEASED, this.scalesBowlModule.model, () => {
                                    const distanceToFunnel = this.scalesBowlModule.model.getWorldPosition(new Vector3()).distanceTo(this.funnelModule.model.getWorldPosition(new Vector3()));
                                    if (distanceToFunnel < 1.1) {
                                        this.actionController.off(ActionControllerEventName.click, this.flaskModule.model);
                                        this.lobby.app.zSpacePickingController.off(PickingControllerEvents.PICKED, this.scalesBowlModule.model);
                                        this.lobby.app.zSpacePickingController.off(PickingControllerEvents.RELEASED, this.scalesBowlModule.model);
                                        callback();
                                    }
                                    else {
                                        PreparationPickingObjects.flyObjectToPrevState(this.scalesBowlModule.model);
                                    }
                                    setTimeout(() => this.scalesBowlModule.model.traverse(el => {
                                        if (el.userData.oldRaycast)
                                            el.raycast = el.userData.oldRaycast;
                                    }));
                                });
                            }
                        };
                        initFunction();
                    }),
                    onAfter: []
                },
                {
                    onBefore: [
                        ['tasksProgress', 'init', 9, 4],
                        ['lobbyScreen', 'setProgress', '4/9'],
                        [
                            'taskScreen', 'init', 'TASK 5',
                            'Fill Flask halfway with distilled water.',
                            ((_a = Viewer.zSpace) === null || _a === void 0 ? void 0 : _a.enabled)
                                ? ('Select the bottle with distilled water and fill the flask up to the first line while tilted.')
                                : ('Select the bottle with distilled water and drag it to the flask. \n ' +
                                    'Once the slider appears, drag the arrow down until the flask filled up to the first line.'),
                            0.52
                        ],
                        ['distilledWaterModule', 'initWaitSelect']
                    ],
                    stepCondition: () => new Promise((resolve, reject) => {
                        this.distilledWaterModule.once('selected', resolve);
                    }),
                    onAfter: []
                },
                {
                    onBefore: [['funnelModule', 'initWaitApply']],
                    stepCondition: () => new Promise((resolve, reject) => {
                        if (!Viewer.controls.zController) {
                            this.funnelModule.once('applied', () => resolve());
                        }
                        else
                            resolve();
                    }),
                    onAfter: []
                },
                {
                    onBefore: [['distilledWaterModule', 'flyToFunnel']],
                    stepCondition: () => new Promise((resolve, reject) => {
                        if (!Viewer.controls.zController) {
                            this.distilledWaterModule.on('filling', (event) => {
                                this.flaskModule.pourDistilledWater(event.data, 0, 3);
                            });
                        }
                        else {
                            let drops = 0;
                            Viewer.on('update', this.flaskModule.uiObject.userData.viewerCallback = () => {
                                this.distilledWaterModule.drops.slice().forEach(drop => {
                                    if (drop.userData.sphere.center.distanceTo(this.flaskModule.flask.localToWorld(new Vector3(0, 0, 0))) < 0.3) {
                                        this.distilledWaterModule.removeDrop(drop);
                                        this.flaskModule.pourDistilledWater(++drops / 50, 0, 3);
                                        if (drops > 50) {
                                            this.lobby.app.zSpacePickingController.off(PickingControllerEvents.PICKED, this.distilledWaterModule.model);
                                            this.lobby.app.zSpacePickingController.off(PickingControllerEvents.RELEASED, this.distilledWaterModule.model);
                                            this.distilledWaterModule.fire('flask_filled');
                                        }
                                    }
                                });
                            });
                        }
                        this.distilledWaterModule.once('flask_filled', () => {
                            this.distilledWaterModule.off('filling');
                            this.flaskModule.uiObject.userData.viewerCallback && Viewer.off('update', this.flaskModule.uiObject.userData.viewerCallback);
                            this.distilledWaterModule.setDynamicLiquidMode(false);
                            resolve();
                        });
                    }),
                },
                {
                    stepCondition: () => new Promise((resolve, reject) => {
                        if (!Viewer.controls.zController) {
                            resolve();
                        }
                        else {
                            this.lobby.app.zSpacePickingController.once(PickingControllerEvents.RELEASED, this.distilledWaterModule.model, () => resolve());
                        }
                        this.distilledWaterModule.once('flask_filled', () => {
                            this.distilledWaterModule.off('filling');
                            this.flaskModule.uiObject.userData.viewerCallback && Viewer.off('update', this.flaskModule.uiObject.userData.viewerCallback);
                            this.distilledWaterModule.setDynamicLiquidMode(false);
                            resolve();
                        });
                    }),
                    onAfter: [['distilledWaterModule', 'setDefaultPositionRotation']]
                },
                // вернуть лейку на стол
                {
                    onBefore: [
                        ['tasksProgress', 'init', 9, 5],
                        ['lobbyScreen', 'setProgress', '5/9'],
                        [
                            'taskScreen', 'init', 'TASK 6',
                            'Swirl the flask to dissolve sodium chloride crystals.',
                            'First remove the funnel from the flask and place it back on the table. \n ' +
                                'Next, select the cap sitting on the table and place it on top of the flask. \n ' +
                                'Finally, select the flask and swirl it to mix the solution.',
                            0.38
                        ],
                        ['funnelModule', 'initWaitSelect']
                    ],
                    stepCondition: () => new Promise((resolve, reject) => {
                        const callback = () => {
                            this.actionController.once(ActionControllerEventName.click, this.table, (event) => {
                                if (Viewer.controls.zController)
                                    return;
                                if (event.orderNumber !== 0) {
                                    callback();
                                    return;
                                }
                                resolve();
                            });
                            if (Viewer.controls.zController && this.lobby.app.zSpacePickingController) {
                                this.lobby.app.zSpacePickingController.on(PickingControllerEvents.RELEASED, this.funnelModule.model, () => {
                                    const distanceToFunnelTablePosition = this.funnelModule.model.getWorldPosition(new Vector3()).distanceTo(this.funnelModule.funnelTablePosition);
                                    if (distanceToFunnelTablePosition < 1.5) {
                                        this.actionController.off(ActionControllerEventName.click, this.table);
                                        this.lobby.app.zSpacePickingController.off(PickingControllerEvents.PICKED, this.funnelModule.model);
                                        this.lobby.app.zSpacePickingController.off(PickingControllerEvents.RELEASED, this.funnelModule.model);
                                        resolve();
                                    }
                                    else {
                                        PreparationPickingObjects.flyObjectToPrevState(this.funnelModule.model);
                                    }
                                    setTimeout(() => this.funnelModule.model.traverse(el => {
                                        if (el.userData.oldRaycast)
                                            el.raycast = el.userData.oldRaycast;
                                    }));
                                });
                            }
                        };
                        const initFunction = () => {
                            this.funnelModule.once('selected', (event) => {
                                if (!this.interaction) {
                                    initFunction();
                                    return;
                                }
                                callback();
                            });
                        };
                        initFunction();
                    }),
                    onAfter: [['funnelModule', 'setDefaultPositionRotation']]
                },
                // надеть пробку на колбу
                {
                    onBefore: [['capModule', 'initWaitSelect']],
                    stepCondition: () => new Promise((resolve, reject) => {
                        const callback = () => {
                            Viewer.pointerController.setObject(null);
                            this.capModule.closeFlask(resolve);
                        };
                        const initFunction = () => {
                            this.actionController.once(ActionControllerEventName.click, this.flaskModule.model, (event) => {
                                if (Viewer.controls.zController)
                                    return;
                                if (!this.interaction || !this.capModule.selected || event.intersectedObject.name === 'pPlane') {
                                    initFunction();
                                    return;
                                }
                                callback();
                            });
                            if (Viewer.controls.zController && this.lobby.app.zSpacePickingController) {
                                this.lobby.app.zSpacePickingController.on(PickingControllerEvents.RELEASED, this.capModule.model, () => {
                                    const distanceToFlask = this.capModule.model.getWorldPosition(new Vector3()).distanceTo(this.flaskModule.flaskTopPosition);
                                    if (distanceToFlask < 1) {
                                        this.actionController.off(ActionControllerEventName.click, this.capModule.model);
                                        this.lobby.app.zSpacePickingController.off(PickingControllerEvents.PICKED, this.capModule.model);
                                        this.lobby.app.zSpacePickingController.off(PickingControllerEvents.RELEASED, this.capModule.model);
                                        this.capModule.model.rotation.set(Math.PI, 0, 0);
                                        this.capModule.closeFlask(resolve);
                                    }
                                    else {
                                        PreparationPickingObjects.flyObjectToPrevState(this.capModule.model, 0);
                                        if (this.capModule.selected) {
                                            this.capModule.model.geometry.rotateZ(Math.PI);
                                        }
                                        this.capModule.selected = false;
                                    }
                                    setTimeout(() => this.capModule.model.traverse(el => {
                                        if (el.userData.oldRaycast)
                                            el.raycast = el.userData.oldRaycast;
                                    }));
                                });
                            }
                        };
                        initFunction();
                    }),
                    onAfter: []
                },
                // взболтать колбу
                {
                    onBefore: [['flaskModule', 'initShake']],
                    stepCondition: () => new Promise((resolve, reject) => {
                        this.flaskModule.once('flask_shaked', resolve);
                    }),
                    onAfter: []
                },
                // Open the cap on bottle
                {
                    onBefore: [
                        ['tasksProgress', 'init', 9, 6],
                        ['lobbyScreen', 'setProgress', '6/9'],
                        [
                            'taskScreen', 'init', 'TASK 7',
                            'Fill Flask to the second line with distilled water.',
                            'First, remove the cap from the flask and place it back on the table. \n ' +
                                'Then, add the funnel, and use the bottle to add distilled water up to the fill line.',
                            0.6
                        ],
                        ['capModule', 'initWaitSelect']
                    ],
                    stepCondition: () => new Promise((resolve, reject) => {
                        const callback = () => {
                            this.actionController.once(ActionControllerEventName.click, this.table, (event) => {
                                if (Viewer.controls.zController)
                                    return;
                                if (event.orderNumber !== 0) {
                                    callback();
                                    return;
                                }
                                this.capModule.model.geometry.rotateZ(Math.PI);
                                resolve();
                            });
                            if (Viewer.controls.zController && this.lobby.app.zSpacePickingController) {
                                this.lobby.app.zSpacePickingController.on(PickingControllerEvents.RELEASED, this.capModule.model, () => {
                                    this.capModule.selected = false;
                                    const distanceToFunnel = this.capModule.model.getWorldPosition(new Vector3()).distanceTo(this.funnelModule.model.getWorldPosition(new Vector3()));
                                    if (distanceToFunnel < 1.5) {
                                        this.actionController.off(ActionControllerEventName.click, this.table);
                                        this.lobby.app.zSpacePickingController.off(PickingControllerEvents.PICKED, this.capModule.model);
                                        this.lobby.app.zSpacePickingController.off(PickingControllerEvents.RELEASED, this.capModule.model);
                                        resolve();
                                    }
                                    else {
                                        PreparationPickingObjects.flyObjectToPrevState(this.capModule.model, 0);
                                    }
                                    setTimeout(() => this.capModule.model.traverse(el => {
                                        if (el.userData.oldRaycast)
                                            el.raycast = el.userData.oldRaycast;
                                    }));
                                });
                            }
                        };
                        const initFunction = () => {
                            this.capModule.once('selected', (event) => {
                                if (!this.interaction) {
                                    initFunction();
                                    return;
                                }
                                callback();
                            });
                        };
                        initFunction();
                    }),
                    onAfter: [['capModule', 'setDefaultPositionRotation']]
                },
                {
                    onBefore: [],
                    stepCondition: () => new Promise((resolve, reject) => {
                        const callback = () => {
                            this.funnelModule.model.rotateZ(Math.PI);
                            Viewer.pointerController.setObject(this.funnelModule.model);
                            this.funnelModule.visibilityShadow(false);
                            resolve();
                        };
                        const initFunction = () => {
                            this.actionController.once(ActionControllerEventName.click, this.funnelModule.model, (event) => {
                                if (Viewer.controls.zController)
                                    return;
                                if (!this.interaction || event.intersectedObject.name === 'pPlane') {
                                    initFunction();
                                    return;
                                }
                                callback();
                            });
                            if (Viewer.controls.zController && this.lobby.app.zSpacePickingController) {
                                let isBeReleased = false;
                                PreparationPickingObjects.saveObjectState(this.funnelModule.model);
                                this.lobby.app.zSpacePickingController.on(PickingControllerEvents.PICKED, this.funnelModule.model, () => {
                                    if (!this.interaction)
                                        return;
                                    Viewer.scene.add(this.funnelModule.model);
                                    this.funnelModule.model.rotateZ(Math.PI);
                                    this.funnelModule.model.rotateZ(Math.PI);
                                    this.funnelModule.visibilityShadow(false);
                                    resolve();
                                });
                                this.lobby.app.zSpacePickingController.on(PickingControllerEvents.MOVED, this.funnelModule.model, () => {
                                    if (!isBeReleased)
                                        this.funnelModule.model.rotateZ(Math.PI);
                                });
                                this.lobby.app.zSpacePickingController.on(PickingControllerEvents.RELEASED, this.funnelModule.model, () => {
                                    isBeReleased = true;
                                });
                            }
                        };
                        initFunction();
                    }),
                    onAfter: []
                },
                {
                    onBefore: [],
                    stepCondition: () => new Promise((resolve, reject) => {
                        const callback = () => {
                            Viewer.pointerController.setObject(null);
                            this.table.add(this.funnelModule.model);
                            this.funnelModule.putInFlask();
                            resolve();
                        };
                        const initFunction = () => {
                            this.actionController.once(ActionControllerEventName.click, this.flaskModule.model, (event) => {
                                if (Viewer.controls.zController)
                                    return;
                                if (!this.interaction || event.intersectedObject.name === 'pPlane') {
                                    initFunction();
                                    return;
                                }
                                callback();
                            });
                            if (Viewer.controls.zController && this.lobby.app.zSpacePickingController) {
                                this.lobby.app.zSpacePickingController.on(PickingControllerEvents.RELEASED, this.funnelModule.model, () => {
                                    const distanceToFlask = this.funnelModule.model.getWorldPosition(new Vector3()).distanceTo(this.flaskModule.flaskTopPosition);
                                    if (distanceToFlask < 1) {
                                        this.actionController.off(ActionControllerEventName.click, this.flaskModule.model);
                                        this.lobby.app.zSpacePickingController.off(PickingControllerEvents.PICKED, this.funnelModule.model);
                                        this.lobby.app.zSpacePickingController.off(PickingControllerEvents.MOVED, this.funnelModule.model);
                                        this.lobby.app.zSpacePickingController.off(PickingControllerEvents.RELEASED, this.funnelModule.model);
                                        this.table.add(this.funnelModule.model);
                                        this.funnelModule.putInFlask();
                                        resolve();
                                    }
                                    else {
                                        PreparationPickingObjects.flyObjectToPrevState(this.funnelModule.model);
                                    }
                                    setTimeout(() => this.funnelModule.model.traverse(el => {
                                        if (el.userData.oldRaycast)
                                            el.raycast = el.userData.oldRaycast;
                                    }));
                                });
                            }
                        };
                        initFunction();
                    }),
                    onAfter: []
                },
                {
                    onBefore: [['distilledWaterModule', 'initWaitSelect']],
                    stepCondition: () => new Promise((resolve, reject) => {
                        this.distilledWaterModule.once('selected', resolve);
                    }),
                    onAfter: []
                },
                {
                    onBefore: [['funnelModule', 'initWaitApply']],
                    stepCondition: () => new Promise((resolve, reject) => {
                        if (!Viewer.controls.zController) {
                            this.funnelModule.once('applied', () => resolve());
                        }
                        else
                            resolve();
                    }),
                    onAfter: []
                },
                {
                    onBefore: [['distilledWaterModule', 'flyToFunnel']],
                    stepCondition: () => new Promise((resolve, reject) => {
                        if (!Viewer.controls.zController) {
                            this.distilledWaterModule.on('filling', (event) => {
                                this.flaskModule.pourDistilledWater(event.data, 3, 5);
                            });
                        }
                        else {
                            let drops = 0;
                            Viewer.on('update', this.flaskModule.uiObject.userData.viewerCallback = () => {
                                this.distilledWaterModule.drops.slice().forEach(drop => {
                                    if (drop.userData.sphere.center.distanceTo(this.flaskModule.flask.localToWorld(new Vector3(0, 0, 0))) < 0.3) {
                                        this.distilledWaterModule.removeDrop(drop);
                                        this.flaskModule.pourDistilledWater(++drops / 50, 3, 5);
                                        if (drops > 50) {
                                            this.lobby.app.zSpacePickingController.off(PickingControllerEvents.PICKED, this.distilledWaterModule.model);
                                            this.lobby.app.zSpacePickingController.off(PickingControllerEvents.RELEASED, this.distilledWaterModule.model);
                                            this.distilledWaterModule.fire('flask_filled');
                                        }
                                    }
                                });
                            });
                        }
                        this.distilledWaterModule.once('flask_filled', () => {
                            this.distilledWaterModule.off('filling');
                            this.flaskModule.uiObject.userData.viewerCallback && Viewer.off('update', this.flaskModule.uiObject.userData.viewerCallback);
                            this.distilledWaterModule.setDynamicLiquidMode(false);
                            resolve();
                        });
                    }),
                },
                {
                    stepCondition: () => new Promise((resolve, reject) => {
                        if (!Viewer.controls.zController) {
                            resolve();
                        }
                        else {
                            this.lobby.app.zSpacePickingController.once(PickingControllerEvents.RELEASED, this.distilledWaterModule.model, () => resolve());
                        }
                        this.distilledWaterModule.once('flask_filled', () => {
                            this.distilledWaterModule.off('filling');
                            this.flaskModule.uiObject.userData.viewerCallback && Viewer.off('update', this.flaskModule.uiObject.userData.viewerCallback);
                            this.distilledWaterModule.setDynamicLiquidMode(false);
                            resolve();
                        });
                    }),
                    onAfter: [['distilledWaterModule', 'setDefaultPositionRotation']]
                },
                // печатать на этикетке
                {
                    onBefore: [
                        ['tasksProgress', 'init', 9, 7],
                        ['lobbyScreen', 'setProgress', '7/9'],
                        [
                            'taskScreen', 'init', 'TASK 8',
                            'Label Jar.',
                            'First, click on the small white label sitting on the table. \n ' +
                                'Next, use the keyboard to type in the symbol for sodium chloride, "NaCl". \n ' +
                                'Finally, place the label on the jar by dragging it over the jar.',
                            0.58
                        ],
                        ['labelModule', 'initWaitSelectForSignature']
                    ],
                    stepCondition: () => new Promise((resolve, reject) => {
                        this.labelModule.once('successfully_signed', resolve);
                        this.labelModule.once('wrong_signed', reject);
                    }),
                    onError: [
                        ['errorModal', 'init', 'Error', 'Wrong value entered. \n Try again.', 'ok'],
                        ['errorModal', 'setVisible', true]
                    ],
                    onAfter: [['labelModule', 'flyOnTable']]
                },
                // приклеить этикетку
                {
                    onBefore: [['labelModule', 'initWaitSelectForApply', this.resultJarModule.bottle]],
                    stepCondition: () => new Promise((resolve, reject) => {
                        this.labelModule.once('label_applied', resolve);
                    }),
                    onAfter: [['labelModule', 'hideModel']]
                },
                // открыть результирующую бутылку
                {
                    onBefore: [
                        ['tasksProgress', 'init', 9, 8],
                        ['lobbyScreen', 'setProgress', '8/9'],
                        [
                            'taskScreen', 'init', 'TASK 9',
                            'Pour the solution from the flask to the jar you just labeled.',
                            'First, remove the funnel from the flask if you have not already done so. \n ' +
                                'Next, click on the lid to open the jar. \n ' +
                                'Then, drag the flask to the jar. \n ' +
                                'Finally, click on the lid to close the jar.',
                            0.4
                        ],
                        ['funnelModule', 'initWaitSelect']
                    ],
                    stepCondition: () => new Promise((resolve, reject) => {
                        const callback = () => {
                            this.actionController.once(ActionControllerEventName.click, this.table, (event) => {
                                if (Viewer.controls.zController)
                                    return;
                                if (event.orderNumber !== 0) {
                                    callback();
                                    return;
                                }
                                resolve();
                            });
                            if (Viewer.controls.zController && this.lobby.app.zSpacePickingController) {
                                this.lobby.app.zSpacePickingController.on(PickingControllerEvents.RELEASED, this.funnelModule.model, () => {
                                    const distanceToFunnelTablePosition = this.funnelModule.model.getWorldPosition(new Vector3()).distanceTo(this.funnelModule.funnelTablePosition);
                                    if (distanceToFunnelTablePosition < 1.5) {
                                        this.actionController.off(ActionControllerEventName.click, this.table);
                                        this.lobby.app.zSpacePickingController.off(PickingControllerEvents.PICKED, this.funnelModule.model);
                                        this.lobby.app.zSpacePickingController.off(PickingControllerEvents.RELEASED, this.funnelModule.model);
                                        resolve();
                                    }
                                    else {
                                        PreparationPickingObjects.flyObjectToPrevState(this.funnelModule.model);
                                    }
                                    setTimeout(() => this.funnelModule.model.traverse(el => {
                                        if (el.userData.oldRaycast)
                                            el.raycast = el.userData.oldRaycast;
                                    }));
                                });
                            }
                        };
                        const initFunction = () => {
                            this.funnelModule.once('selected', (event) => {
                                if (!this.interaction) {
                                    initFunction();
                                    return;
                                }
                                callback();
                            });
                        };
                        initFunction();
                    }),
                    onAfter: [['funnelModule', 'setDefaultPositionRotation']]
                },
                // вернуть лейку на стол
                {
                    onBefore: [['resultJarModule', 'waitToggleCap']],
                    stepCondition: () => new Promise((resolve, reject) => {
                        this.resultJarModule.once('cap_toggled', resolve);
                    }),
                },
                // перетаскивание колбы
                {
                    onBefore: [['flaskModule', 'initDragAndDropLabel', this.resultJarModule.bottle]],
                    stepCondition: () => new Promise((resolve, reject) => {
                        this.flaskModule.once('flask_is_back', resolve);
                    }),
                },
                // закрыть результирующую бутылку
                {
                    onBefore: [['resultJarModule', 'waitToggleCap', false]],
                    stepCondition: () => new Promise((resolve, reject) => {
                        const callback = () => {
                            this.interaction = false;
                            if (this.scalesBowlModule.getWeight() > 6.0 || this.scalesBowlModule.getWeight() < 5.6 || this.flaskModule.numbCurrentWaterSectionNoCeil < 5) {
                                this.levelFinished = false;
                                this.welcomeScreen.once('ok', () => this.welcomeExitToLobby());
                                this.welcomeScreen.once('secondButtonClick', () => {
                                    this.welcomeScreen.uiObject.visible = false;
                                    this.restart();
                                });
                                reject();
                            }
                            else {
                                this.levelFinished = true;
                                this.welcomeScreen.on('ok', () => this.welcomeExitToLobby());
                                resolve();
                            }
                        };
                        const initFunction = () => {
                            this.resultJarModule.once('cap_toggled', () => {
                                if (!this.interaction) {
                                    initFunction();
                                    return;
                                }
                                callback();
                            });
                        };
                        initFunction();
                    }),
                    onError: [
                        ['welcomeScreen', 'init', 'Experiment failed!', 'Ooops! Seems like the ratio of NaCl and water is not quite right. Try again!', 'Back to Lobby', 'Try Again!'],
                        ['welcomeScreen', 'show', true],
                        ['lobbyScreen', 'setProgress', '0/9']
                    ],
                    onAfter: [
                        ['welcomeScreen', 'init', 'Experiment finished!', 'You have successfully accomplished the experiment.', 'Back to Lobby'],
                        ['welcomeScreen', 'show', true],
                        ['lobbyScreen', 'setProgress', '9/9']
                    ]
                }
            ]
        };
        const scenarioProcessor = new ScenarioProcessor(this.scenarioConfig);
        scenarioProcessor.init();
    }
    welcomeExitToLobby() {
        this.interaction = false;
        this.fire('exit', new ParentEvent('exit'));
    }
    restart() {
        this.title.setProgress('0/9');
        this.pointerController.setObject(null);
        this.lobby.app.zSpacePickingController && this.lobby.app.zSpacePickingController.currentObject && this.lobby.app.zSpacePickingController.forceRelease();
        this.interaction = false;
        this.welcomeScreen.off('ok', this.welcomeExitToLobby);
        this.jarModule.applyButton.dispose();
        this.initModules();
        this.initScenario();
    }
    showInfo(isShow = true) {
        console.log('showInfo', isShow, Viewer.controls.zController);
        this.title.uiObject.visible = isShow;
        this.uiContainer.visible = !isShow;
        if (Viewer.controls.zController) {
            this.spoonModule_0_1.uiObject.visible = this.spoonModule_0_5.uiObject.visible = this.spoonModule_1.uiObject.visible = !isShow;
        }
    }
    hideAllInfo() {
        this.uiContainer.visible = this.title.uiObject.visible = false;
    }
    update() {
    }
}
